import { render, staticRenderFns } from "./PrjOverview.vue?vue&type=template&id=34b92614&scoped=true&"
import script from "./PrjOverview.vue?vue&type=script&lang=ts&"
export * from "./PrjOverview.vue?vue&type=script&lang=ts&"
import style0 from "./PrjOverview.vue?vue&type=style&index=0&id=34b92614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b92614",
  null
  
)

export default component.exports